"use client";

import { colorPartsOf } from "@v2/lib/colorParts";
import { usePdpVariant } from "./PdpVariantContext";
import PdpDesktopGallery from "./PdpDesktopGallery";

type Props = {
    siteProductTitle: string;
    frameTypeAttr?: string;
    materialAttr?: string;
    brandName?: string;
};

export default function PdpDesktopGallerySection({ siteProductTitle, frameTypeAttr, materialAttr, brandName }: Props) {
    const { showProduct } = usePdpVariant();

    const supersedeAlt = [
        showProduct.product_class?.title,
        frameTypeAttr,
        materialAttr,
        brandName,
        ...colorPartsOf(showProduct).map(part => part.colors.map(c => c.title).join(", ")),
    ].filter(Boolean).join(" - ");

    return (
        <PdpDesktopGallery
            images={showProduct.images}
            details={{
                title: siteProductTitle,
                color_code: showProduct.color_code,
                supersede_alt: supersedeAlt,
            }}
        />
    );
}
